<script setup lang="ts">
import { AppConfirmationModal } from '@libs/ui';

import { useBookTripStore } from '../../../core/stores/bookTrip/bookTripStore';

function close(): void {
  bookTripStore.clearBookingError();
}

const bookTripStore = useBookTripStore();
</script>

<template>
  <AppConfirmationModal @close="close" @confirm="close">
    <template #title>
      {{ bookTripStore.bookingError?.header }}
    </template>

    <template #content>
      {{ bookTripStore.bookingError?.descrtiption }}
    </template>

    <template #applyButton>{{ $t('planner.ok') }}</template>
  </AppConfirmationModal>
</template>
